<template>
    <main id="homepage">
        <div class="homepage-content">
            <div class="switch-view">
                <Bttn
                    :class="['point-view', { active: view === 'trips' }]"
                    icon-only
                    icon="location_on"
                    @click="switchView('trips')"
                />
                <Bttn
                    :class="[
                        'bucket-list-view',
                        { active: view === 'countries' },
                    ]"
                    icon-only
                    icon="checklist"
                    @click="switchView('countries')"
                />
            </div>
            <div v-if="!loading" class="homepage-map">
                <keep-alive>
                    <PointMap
                        v-if="view === 'trips'"
                        :geos="tripLocations"
                        :geo-style="dotStyle"
                        popup-on="click"
                    >
                        <template #popup="{ geos }">
                            <ul class="map-popup-card">
                                <MapPopupCard
                                    v-for="geo in geos"
                                    :key="geo.getMeta().locationId"
                                    :title="geo.getMeta().name"
                                    :to="geo.getMeta().url"
                                    :emoji="
                                        impressionEmoji(
                                            geo.getMeta().impression
                                        )
                                    "
                                    :lines="locationLines(geo.getMeta())"
                                />
                            </ul>
                        </template>
                    </PointMap>
                    <RegionMap v-else :geos="countries" popup-on="click">
                        <template #popup="{ geos }">
                            <ul class="map-popup-card">
                                <MapPopupCard
                                    v-for="geo in geos"
                                    :key="geo.country_code"
                                    :title="`${geo.getFlag()} ${geo.country}`"
                                    :lines="countryLines(geo.getMeta())"
                                >
                                    <hr
                                        v-if="
                                            geo.getMeta().bucket_list_entries
                                                .length
                                        "
                                    />
                                    <div class="map-popup-pills">
                                        <router-link
                                            v-for="list in geo.getMeta()
                                                .bucket_list_entries"
                                            :key="list.id"
                                            :to="{
                                                name: 'bucketListView',
                                                params: { id: list.id },
                                            }"
                                        >
                                            {{ list.checked ? "✓" : "○" }}
                                            {{ list.name }}
                                        </router-link>
                                    </div>
                                </MapPopupCard>
                            </ul>
                        </template>
                    </RegionMap>
                </keep-alive>
            </div>
        </div>
    </main>
</template>

<script>
import PointMap from "js/components/maps/PointMap";
import RegionMap from "js/components/maps/RegionMap";
import MapPopupCard from "js/components/maps/MapPopupCard";
import { dotStyle } from "js/components/maps/styles";
import { fetch } from "js/lib/server.js";
import { Geo } from "js/lib/geocoding.js";
import { formatDateRange } from "js/lib/dates.js";
import iconList from "js/tripper/icons.js";

export default {
    name: "Home",
    components: {
        PointMap,
        RegionMap,
        MapPopupCard,
    },
    data() {
        return {
            loading: true,
            tripLocations: [],
            countries: [],
        };
    },
    computed: {
        view() {
            return this.$route.query.view === "countries"
                ? "countries"
                : "trips";
        },
    },
    mounted() {
        fetch("/api/stats/maps").then((response) => {
            const { locations, bucket_list_items: countries } =
                response.data.maps;
            this.tripLocations = locations.map((item) => {
                return new Geo(item.geo).setMeta({
                    name: item.location,
                    trip: item.trip,
                    locationId: item.location_id,
                    impression: item.impression,
                    nights: item.nights,
                    tripStart: item.trip_start,
                    tripEnd: item.trip_end,
                    url: {
                        name: "tripView",
                        params: {
                            id: item.trip_id,
                        },
                        hash: `#location-${item.location_id}`,
                    },
                });
            });
            this.countries = countries.map((item) => {
                return new Geo(item.geo).setValue(item.checked).setMeta(item);
            });
            this.loading = false;
        });
    },
    methods: {
        dotStyle,
        switchView(view) {
            this.$router.replace({
                query: view === "trips" ? {} : { view },
            });
        },
        impressionEmoji(impression) {
            return impression > 0 ? iconList.impressionEmoji[impression] : null;
        },
        locationLines(meta) {
            const trip = [
                meta.trip,
                formatDateRange(meta.tripStart, meta.tripEnd),
            ]
                .filter(Boolean)
                .join(" · ");

            return meta.nights > 0
                ? [
                      trip,
                      `${meta.nights} ${meta.nights === 1 ? "night" : "nights"}`,
                  ]
                : [trip];
        },
        countryLines(meta) {
            let status = "Not visited yet";
            if (meta.trips > 0) {
                status = `Visited · ${meta.trips} ${meta.trips === 1 ? "trip" : "trips"}`;
            } else if (meta.checked) {
                status = "Visited";
            }

            return [status];
        },
    },
};
</script>
